import { Button, Chip, Box, Typography, TextField } from "@mui/material";
import { width } from "@mui/system";
import ColumnHeaderWithSearch from "../../SearchBar";

const DashboardColumns = (handleAction, handleColumnFilter, columnFilters) => [
  { 
    field: "USER_NAME", 
    headerName: "User Name", 
    flex: 1, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title="User Name"
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  { 
    field: "USER_EMAIL", 
    headerName: "User Email", 
    flex: 1.5, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title="User Email"
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  { 
    field: "CONTACT_NO", 
    headerName: "Contact Number", 
    flex: 1, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title="Contact Number"
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  { 
    field: "TOTAL_LICENSES", 
    headerName: "Total Licenses", 
    flex: 1, 
    filterable: true,
    align: "right",
    headerAlign: "right",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title="Total Licenses"
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="right"
      />
    )
  },
  {
    field: "REMAINING_LICENSES",
    headerName: "Remaining Licenses",
    filterable: true,
    width: 130,
    align: "right",
    headerAlign: "right",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title="Remaining Licenses"
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="right"
      />
    )
  },
  {
    field: "STATUS",
    headerName: "Status",
    flex: 1,
    filterable: true,
    align: "center",
    headerAlign: "center",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title="Status"
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="center"
      />
    ),
    renderCell: (params) => {
      const status = params.row.STATUS;
      const isActive = status === 'ACTIVE';
      
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Chip
            label={status || 'Unknown'}
            color={isActive ? "success" : "default"}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: '0.75rem',
              '&.MuiChip-outlined': {
                borderColor: isActive ? '#4caf50' : '#9e9e9e',
                color: isActive ? '#4caf50' : '#9e9e9e',
              }
            }}
          />
        </Box>
      );
    },
  },
  {
  field: "action",
  headerName: "Action",
  flex: 1,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",           // ensures button stays in middle
    }}>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{
          minHeight: "32px",
          minWidth: "60px",
          fontSize: "0.75rem",
          padding: "4px 8px",
          whiteSpace: "nowrap",
          textTransform: "none",
        }}
        onClick={() => handleAction(params.row)}
        disabled={params.row.STATUS !== "ACTIVE"}
      >
        Add Licence
      </Button>
    </div>
  ),
}
];


export default DashboardColumns;
